import { useContext } from 'react';

import { Field, RichText } from '@sitecore-jss/sitecore-jss-nextjs';

import { WildCardRouteContext } from 'src/context/WildCardRoute/WildCardRouteContext';

import { ComponentProps } from 'src/lib/ComponentProps';

import IsSitecoreEditing from 'src/utils/isSitecoreEditing';
import { isRcniLearningModule } from 'src/utils/isTemplate';

import styles from './LearningModuleOverviewSyllabus.module.css';

type LearningModuleOverviewSyllabusProps = ComponentProps & {
	fields: {
		Syllabus: Field<string>;
	};
};

export default function LearningModuleOverviewSyllabus(props: LearningModuleOverviewSyllabusProps): JSX.Element {
	const WildCardRoute = useContext(WildCardRouteContext);
	const isEditing = IsSitecoreEditing();

	if (
		!isRcniLearningModule(WildCardRoute?.wildCardItemInfo?.TemplateId) ||
		(!isEditing && (!props.fields?.Syllabus || !props.fields?.Syllabus.value))
	) {
		return <></>;
	}

	return (
		<div className={styles.contentOverviewCourseInformation} id="learning-module-syllabus" data-display-pdf-download>
			<RichText className={styles.syllabus} field={props.fields.Syllabus} />
		</div>
	);
}
